var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuBillingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-495.000000, -363.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy",
    transform: "translate(495.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_Billing_Active",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,12 L12,12 L12,1 C12,0.447 11.553,0 11,0 L1,0 C0.447,0 0,0.447 0,1 L0,13 C0,14.657 1.343,16 3,16 L13,16 C14.657,16 16,14.657 16,13 C16,12.447 15.553,12 15,12 Z",
    id: "Combined-Shape",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,13 C4,13.553 3.553,14 3,14 C2.447,14 2,13.553 2,13 L2,2 L10,2 L10,12 L5,12 C4.447,12 4,12.447 4,13 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,14 L5.816,14 C5.928,13.686 6,13.353 6,13 L14,13 C14,13.553 13.553,14 13,14 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,4 L5,4 C4.447,4 4,4.447 4,5 C4,5.553 4.447,6 5,6 L7,6 C7.553,6 8,5.553 8,5 C8,4.447 7.553,4 7,4 Z",
    id: "Path",
    fill: "#212121"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuBillingActive);
export default __webpack_public_path__ + "static/media/Icon-Menu_Billing_Active.774ffd7638ea4e97b06e3d65d2924c0a.svg";
export { ForwardRef as ReactComponent };